import { useMutation } from '@apollo/client';
import { SAVE_TRAIT_ASSESSMENT_PROGRESS } from '../../apollo/mutations/forcedChoice';

const useTraitAssessmentProgress = () => {
  const [saveProgress, { loading, error }] = useMutation(SAVE_TRAIT_ASSESSMENT_PROGRESS);

  return { saveProgress, loading, error };
};

export default useTraitAssessmentProgress;
